import { ShieldAlert } from "lucide-react";
import type { ConfirmationRequest } from "../types/chat";

function formatRecipients(value: unknown): string {
  if (Array.isArray(value)) return value.filter(Boolean).join(", ") || "recipient";
  if (typeof value === "string" && value.trim()) return value;
  return "recipient";
}

export const ACTION_DESCRIPTIONS: Record<string, (input: Record<string, unknown>) => string> = {
  send_email: (input) => `Send email to ${formatRecipients(input.to)} \u2014 "${input.subject ?? "(no subject)"}"`,
  create_event: (input) => `Create calendar event: "${input.title ?? "(untitled)"}" at ${input.start ?? "TBD"}`,
  schedule_meeting: (input) => `Create video meeting: "${input.name ?? "Meeting"}"`,
};

interface ActionConfirmationProps {
  confirmation: ConfirmationRequest;
  onConfirm: () => void;
  onReject: () => void;
}

export function ActionConfirmation({ confirmation, onConfirm, onReject }: ActionConfirmationProps) {
  const descFn = ACTION_DESCRIPTIONS[confirmation.tool_name];
  const description = descFn ? descFn(confirmation.input) : `Execute: ${confirmation.tool_name}`;

  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 dark:bg-amber-950/30 dark:border-amber-800 p-4 space-y-3">
      <div className="flex items-start gap-2">
        <ShieldAlert className="size-5 text-amber-600 dark:text-amber-400 shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-semibold text-amber-800 dark:text-amber-200">Action requires confirmation</p>
          <p className="text-sm text-amber-700 dark:text-amber-300 mt-1">{description}</p>
        </div>
      </div>
      <div className="flex gap-2 ml-7">
        <button
          type="button"
          onClick={onConfirm}
          className="px-4 h-8 rounded-lg bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 transition-colors"
        >
          Confirm
        </button>
        <button
          type="button"
          onClick={onReject}
          className="px-4 h-8 rounded-lg bg-muted text-muted-foreground text-sm font-medium hover:bg-muted/80 transition-colors"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
